

































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { apiStaffAdd, apiStaffEdit, apiStaffDetail, apiStaffAvailableUsers, apiWorkerTypeList, apiSalaryRuleLists } from '@/api/staff'
import { RequestPaging } from '@/utils/util'
import MaterialSelect from '@/components/material-select/index.vue'
import AreaSelect from '@/components/area-select.vue'

@Component({
  components: {
    MaterialSelect,
    AreaSelect
  }
})
export default class StaffEdit extends Vue {
    form: any = {
      staff_name: '',
      staff_no: '',
      mobile: '',
      gender: 1,
      birth_date: null,
      avatar: '',
      employment_type: 1,
      worker_type_id: null,
      hire_date: null,
      province: '',
      city: '',
      district: '',
      max_daily_orders: 3,
      available_days: '1,2,3,4,5,6,7',
      available_time: '09:00-18:00',
      salary_rule_id: 0,
      bank_name: '',
      bank_account: '',
      bank_account_name: '',
      id_card: '',
      id_card_front: '',
      id_card_back: '',
      certificates: '',
      emergency_contact: '',
      emergency_phone: '',
      address: '',
      education: '',
      work_experience: 0,
      skills: '',
      remark: '',
      user_id: null,
      user_name: ''
    }

    // 工单记录相关数据
    serviceOrderHistory: any[] = []
    serviceOrderLoading = false

    // 打卡记录对话框
    checkinDialogVisible = false
    currentCheckinRecords: any[] = []

    // 用户选择相关
    userSelectDialogVisible = false
    availableUsers: any[] = []
    userLoading = false
    userQuery: any = {
      keyword: ''
    }

    userPager = new RequestPaging()

    // 定义tab顺序
    tabOrder = ['basic', 'work', 'salary', 'certificate', 'other']

    // 用于页面展示的数组数据
    selectedDays: number[] = [1, 2, 3, 4, 5, 6, 7]
    timeRanges: Array<{start: string, end: string}> = [{ start: '09:00', end: '18:00' }]
    certificateUrls: string[] = []
    selectedSkills: string[] = []

    rules = {
      staff_name: [
        { required: true, message: '请输入员工姓名', trigger: 'blur' },
        { max: 100, message: '员工姓名不能超过100个字符', trigger: 'blur' }
      ],
      staff_no: [
        { required: true, message: '员工编号不能为空', trigger: 'blur' },
        { max: 50, message: '员工编号不能超过50个字符', trigger: 'blur' }
      ],
      mobile: [
        { required: true, message: '请输入手机号码', trigger: 'blur' },
        { pattern: /^1[3-9]\d{9}$/, message: '手机号码格式不正确', trigger: 'blur' }
      ],
      employment_type: [
        { required: true, message: '请选择雇佣类型', trigger: 'change' }
      ],
      worker_type_id: [
        { required: true, message: '请选择工种', trigger: 'change' }
      ],
      hire_date: [
        { required: true, message: '请选择入职日期', trigger: 'change' }
      ]
    }

    activeTab = 'basic'
    loading = false
    workerTypeList: any[] = []
    salaryRuleList: any[] = []
    skillOptions = ['沟通能力', '团队合作', '解决问题', '时间管理', '客户服务', '清洁技能', '维修技能', '设备操作']

    get isEdit () {
      return this.$route.query.id && this.$route.name === 'staff_edit'
    }

    get isView () {
      return this.$route.name === 'staff_detail'
    }

    get pageTitle () {
      if (this.isView) {
        return '员工详情'
      }
      return this.isEdit ? '编辑员工' : '新增员工'
    }

    get alertTitle () {
      if (this.isView) {
        return '查看员工详细信息。'
      }
      return this.isEdit
        ? '温馨提示：编辑员工信息，修改后会影响相关排班和薪酬计算。'
        : '温馨提示：新增员工需要完善基本信息、工作信息、薪酬信息等内容。'
    }

    // 出生日期选择限制：不能选择未来日期
    birthDateOptions = {
      disabledDate (time: any) {
        return time.getTime() > Date.now()
      }
    }

    // 下一步
    nextTab () {
      const currentIndex = this.tabOrder.indexOf(this.activeTab)
      if (currentIndex < this.tabOrder.length - 1) {
        this.activeTab = this.tabOrder[currentIndex + 1]
      }
    }

    // 上一步
    prevTab () {
      const currentIndex = this.tabOrder.indexOf(this.activeTab)
      if (currentIndex > 0) {
        this.activeTab = this.tabOrder[currentIndex - 1]
      }
    }

    // 更新时间段
    updateAvailableTime () {
      this.form.available_time = this.timeRanges
        .filter(range => range.start && range.end)
        .map(range => `${range.start}-${range.end}`)
        .join(',')
    }

    addTimeRange () {
      this.timeRanges.push({ start: '09:00', end: '18:00' })
      this.updateAvailableTime()
    }

    removeTimeRange (index: number) {
      this.timeRanges.splice(index, 1)
      this.updateAvailableTime()
    }

    handleSubmit () {
      (this.$refs.formRef as any).validate((valid: boolean) => {
        if (valid) {
          this.loading = true

          try {
            // 转换可工作日期为逗号分隔字符串
            this.form.available_days = this.selectedDays.sort((a, b) => a - b).join(',')

            // 转换资质证书为逗号分隔字符串
            if (Array.isArray(this.certificateUrls)) {
              const urls = this.certificateUrls.map((item: any) => {
                if (typeof item === 'string') {
                  return item
                } else if (item && typeof item === 'object') {
                  return item.url || item.path || ''
                }
                return ''
              }).filter((url: string) => url.trim() !== '')

              this.form.certificates = urls.join(',')
            } else {
              this.form.certificates = ''
            }

            // 转换技能为逗号分隔字符串
            this.form.skills = this.selectedSkills.join(',')

            // 转换省市区为数字（根据表结构需要）
            const submitData = {
              ...this.form,
              province: this.form.province ? Number(this.form.province) : null,
              city: this.form.city ? Number(this.form.city) : null,
              district: this.form.district ? Number(this.form.district) : null,
              birth_date: this.form.birth_date ? Math.floor(this.form.birth_date / 1000) : null,
              hire_date: this.form.hire_date ? Math.floor(this.form.hire_date / 1000) : null
            }

            const api = this.isEdit ? apiStaffEdit : apiStaffAdd
            const params = this.isEdit
              ? { id: this.$route.query.id, ...submitData }
              : submitData

            api(params).then(() => {
              this.$router.push('/staff/lists')
            }).catch(() => {
              this.loading = false
            })
          } catch (error) {
            console.error('处理提交数据出错:', error)
            this.loading = false
          }
        }
      })
    }

    // 处理编辑按钮点击
    handleEdit () {
      this.$router.push({ path: '/staff/edit', query: { id: this.$route.query.id } })
    }

    // 打开用户选择对话框
    handleBindUser () {
      this.userSelectDialogVisible = true
      this.getAvailableUsers(1)
    }

    // 获取可用用户列表
    getAvailableUsers (page?: number) {
      page && (this.userPager.page = page)
      this.userLoading = true
      this.userPager
        .request({
          callback: apiStaffAvailableUsers,
          params: {
            ...this.userQuery
          }
        })
        .then((res: any) => {
          this.availableUsers = res.lists || []
        })
        .finally(() => {
          this.userLoading = false
        })
    }

    // 处理用户选择
    bindUser (user: any) {
      this.form.user_id = user.id
      this.form.user_name = user.nickname || user.real_name
      this.userSelectDialogVisible = false
    }

    handleUnbindUser () {
      this.form.user_id = null
      this.form.user_name = ''
    }

    // 处理用户分页大小变化
    handleUserSizeChange (size: number) {
      this.userPager.size = size
      this.getAvailableUsers()
    }

    // 处理用户分页页码变化
    handleUserCurrentChange (page: number) {
      this.userPager.page = page
      this.getAvailableUsers()
    }

    getStaffDetail () {
      if (this.$route.query.id) {
        apiStaffDetail({ id: this.$route.query.id }).then((res: any) => {
          const data = res || {}

          // 填充表单数据
          Object.keys(this.form).forEach(key => {
            if (data[key] !== undefined && data[key] !== null) {
              this.form[key] = data[key]
            }
          })

          // 处理可工作日期
          if (data.available_days) {
            try {
              this.selectedDays = data.available_days.split(',').map((day: string) => parseInt(day, 10)).filter((day: number) => !isNaN(day))
            } catch (e) {
              console.error('解析可工作日期失败', e)
              this.selectedDays = [1, 2, 3, 4, 5, 6, 7]
            }
          } else {
            this.selectedDays = [1, 2, 3, 4, 5, 6, 7]
          }

          // 处理可工作时间段
          if (data.available_time) {
            try {
              const timeParts = data.available_time.split(',')
              this.timeRanges = timeParts.map((time: string) => {
                const [start, end] = time.split('-')
                return { start: start || '09:00', end: end || '18:00' }
              })
            } catch (e) {
              console.error('解析可工作时间段失败', e)
              this.timeRanges = [{ start: '09:00', end: '18:00' }]
              this.form.available_time = '09:00-18:00'
            }
          } else {
            this.timeRanges = [{ start: '09:00', end: '18:00' }]
            this.form.available_time = '09:00-18:00'
          }

          // 处理资质证书
          if (data.certificates) {
            try {
              if (Array.isArray(data.certificates)) {
                this.certificateUrls = data.certificates
              } else if (typeof data.certificates === 'string') {
                this.certificateUrls = data.certificates.split(',').filter((url: string) => url.trim() !== '')
              } else {
                this.certificateUrls = []
              }
            } catch (e) {
              console.error('解析资质证书失败', e)
              this.certificateUrls = []
            }
          } else {
            this.certificateUrls = []
          }

          // 处理技能
          if (data.skills) {
            try {
              if (Array.isArray(data.skills)) {
                this.selectedSkills = data.skills
              } else if (typeof data.skills === 'string') {
                this.selectedSkills = data.skills.split(',').filter((skill: string) => skill.trim() !== '')
              } else {
                this.selectedSkills = []
              }
            } catch (e) {
              console.error('解析技能失败', e)
              this.selectedSkills = []
            }
          } else {
            this.selectedSkills = []
          }

          // 处理工单记录
          if (data.service_order_history) {
            try {
              this.serviceOrderHistory = Array.isArray(data.service_order_history) ? data.service_order_history : []
            } catch (e) {
              console.error('解析工单记录失败', e)
              this.serviceOrderHistory = []
            }
          } else {
            this.serviceOrderHistory = []
          }

          // 处理时间戳
          if (data.birth_date) {
            this.form.birth_date = data.birth_date * 1000
          }
          if (data.hire_date) {
            this.form.hire_date = data.hire_date * 1000
          }
        })
      }
    }

    getWorkerTypeList () {
      apiWorkerTypeList().then((res: any) => {
        this.workerTypeList = res || []
      })
    }

    getSalaryRuleList () {
      apiSalaryRuleLists({ page: 1, size: 1000 }).then((res: any) => {
        this.salaryRuleList = res.lists || []
      })
    }

    // 获取工单状态标签
    getOrderStatusLabel (status: number): string {
      const statusMap: any = {
        1: '待指派',
        2: '已指派',
        3: '进行中',
        4: '已完成',
        5: '已验收',
        6: '已取消',
        7: '已转单',
        8: '需补差价',
        9: '已报价'
      }
      return statusMap[status] || '未知'
    }

    // 获取工单状态样式类型
    getOrderStatusType (status: number): string {
      const statusMap: any = {
        1: 'info',
        2: 'primary',
        3: 'warning',
        4: 'success',
        5: 'success',
        6: 'danger',
        7: 'warning',
        8: 'warning',
        9: 'info'
      }
      return statusMap[status] || 'info'
    }

    // 显示打卡记录
    showCheckinRecords (records: any[]) {
      this.currentCheckinRecords = records
      this.checkinDialogVisible = true
    }

    created () {
      this.getWorkerTypeList()
      this.getSalaryRuleList()

      // 确保certificateUrls是数组
      this.certificateUrls = []

      if (!this.isEdit && !this.isView) {
        // 生成员工编号
        const date = new Date()
        const year = date.getFullYear()
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0')
        this.form.staff_no = `S${year}${month}${day}${random}`

        // 设置默认入职日期为今天
        this.form.hire_date = Date.now()
      } else {
        this.getStaffDetail()
      }
    }
}
